import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_c054os9f: FaireBrandEntity = {
  token: "b_c054os9f",
  type: "brand",
  name: "Young Threads",
  avatarUrl:
    "https://cdn.faire.com/fastly/be59b2155b384c85da63cc8ff22aea7d59a54ed50e6113942b147a2101971c9d.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/d7e43a118f1d7a67f80e9a326c469ce5c325eaead862b4ccbbf60fa825a3289c.png",
  logoUrl:
    "https://cdn.faire.com/fastly/be59b2155b384c85da63cc8ff22aea7d59a54ed50e6113942b147a2101971c9d.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/d7e43a118f1d7a67f80e9a326c469ce5c325eaead862b4ccbbf60fa825a3289c.png",
  location: "New York City, NY, USA",
  minimumOrderDollars: 100,
  rating: 4.9,
  reviewCount: 606,
  isTopShop: true,
  isInsider: true,
  description:
    "Young Threads started in NYC with a simple goal: to create beautiful, artisan-inspired clothing that empowers the women who wear it and supports the makers behind it. Our brand is rooted in a bohemian spirit, using repurposed fabrics to create modern, hand-finished patchwork garments.\n\nEvery piece is ethically crafted in India using unique, in-house dyeing processes that provide a charm and character you won’t find anywhere else. We believe fashion should be a force for good, which is why we’ve made inclusivity easy—now offering size-ratio pre-packs across Regular and Plus ranges so you can bring a perfect, unique fit to your entire community. ",
  meta: {
    source: "api",
    importedAt: "2026-07-17T18:40:35.439Z",
    importedBy: "entity-db-cli",
  },
};
